export default "__VITE_ASSET__FjcWzYlp__"